import { render, staticRenderFns } from "./SecondaryNav.vue?vue&type=template&id=87c01392&scoped=true"
import script from "./SecondaryNav.vue?vue&type=script&lang=js"
export * from "./SecondaryNav.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNav.vue?vue&type=style&index=0&id=87c01392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c01392",
  null
  
)

export default component.exports